
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import router from "@/router";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class RelaySelectLocationSize extends Vue {

  @Prop({default: () => []})
  public sizes: any[];

  @Getter private isMobile: boolean;

  private selectedSizeId: number = null;

  private cancel(): void {
    this.$emit("cancel");
    this.selectedSizeId = null;
  }

  private confirm(): void {
    this.$emit("confirm", this.selectedSizeId);
    this.selectedSizeId = null;
  }

}
